import { render, staticRenderFns } from "./dialog-choose-favor.vue?vue&type=template&id=09da9d5a&scoped=true"
import script from "./dialog-choose-favor.vue?vue&type=script&lang=js"
export * from "./dialog-choose-favor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09da9d5a",
  null
  
)

export default component.exports